import React from 'react';

/**
 * Elegant placeholder mock for product images.
 * Will be replaced by uploaded transparent PNGs later.
 */
export default function ProductMock({ variant = 'bottle', label = 'DOWAKUM', badge = 'PREMIUM', n = '01' }) {
  const cls = variant === 'tube' ? 'tube' : variant === 'box' ? 'box' : '';
  return (
    <div className={`dwk-product-mock ${cls}`} aria-label={`${label} ${badge}`}>
      <div className="bottle">
        <div className="cap" />
        <div className="label">{label}</div>
        <div className="badge">{badge}</div>
        <div className="n">N° {n}</div>
      </div>
    </div>
  );
}
